import { render, staticRenderFns } from "./SupplierInvoices.vue?vue&type=template&id=18d21e26&"
import script from "./SupplierInvoices.vue?vue&type=script&lang=js&"
export * from "./SupplierInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports